import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ReportsServiceService} from '../../../../services/reports-service';

@Component({
  selector: 'app-timing-analysis-report',
  templateUrl: './timing-analysis-report.component.html',
  styleUrls: ['./timing-analysis-report.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TimingAnalysisReportComponent implements OnInit {

  constructor(private reportService: ReportsServiceService) { }

  filter: any;
  filterCollapse$: BehaviorSubject<boolean>;
  result: any;
  errorMessage = '';

  ngOnInit() {
    this.filterCollapse$ = new BehaviorSubject(false);
  }

  searchReport(filter) {
    this.filter = filter;
    const specifiedFilter = {
      businessProcessId: filter.businessProcessId,
      endDateTime: filter.dateRange.end,
      firstRange: filter.firstRange,
      grouping: filter.grouping,
      secondRange: filter.secondRange,
      startDateTime: filter.dateRange.start,
      stateLifeCycle: filter.stateLifeCycleValue,
      thirdRange: filter.thirdRange
    };
    this.filterCollapse$.next(true);

    this.reportService.getBusinessProcessInstanceTimesAndAmount(specifiedFilter).subscribe(
      res => {
        this.result = res;
        },
      error1 => this.errorMessage = error1
    );
  }
}
